import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/use-auth";
import { t } from "../i18n";
import { Sidebar } from "./Sidebar";

export function Layout(): React.JSX.Element {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <div style={styles.loading}>{t("common.loading")}</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div style={styles.wrapper}>
      <Sidebar />
      <main style={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  wrapper: {
    display: "flex",
    minHeight: "100vh",
  },
  main: {
    flex: 1,
    marginLeft: "var(--sidebar-width)",
    padding: "24px 32px",
    background: "var(--color-bg)",
    minHeight: "100vh",
  },
  loading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    fontSize: 14,
    color: "var(--color-text-secondary)",
  },
};
